const ua = window.navigator.userAgent;
export const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1; // android终端或者uc浏览器
export const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
// 纯血鸿蒙（ArkWeb），不含 Android 兼容层
export const isHarmonyOS = /ArkWeb/i.test(ua);
/**
 * 获取 ios 大版本号
 */
export function getIOSVersion() {
  const verion = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
  return parseInt(verion[1], 10);
}



// WEBPACK FOOTER //
// ./src/lib/call-app/io.js